import type { Ref } from 'react';
import React, { useMemo } from 'react';
import merge from 'deepmerge';
import type { TableProps as MuiTableProps } from '@mui/material';
import { Table as MuiTable } from '@mui/material';
import type { TableContextValues } from './TableContext';
import { TableContext } from './TableContext';

export type TableProps = MuiTableProps & Partial<TableContextValues>;

const spacedRowsTableSx = {
    whiteSpace: 'nowrap',
    borderCollapse: 'separate',
    borderSpacing: '0 10px',
    px: 1,
};

const Table = (
    { spacedOutRows = false, sx, children, ...tableProps }: TableProps,
    ref: Ref<any>,
) => {
    const tableContextVals = useMemo<TableContextValues>(
        () => ({ spacedOutRows }),
        [spacedOutRows],
    );

    const actualSx = useMemo(
        () =>
            (spacedOutRows
                ? (merge(spacedRowsTableSx, sx ?? ({} as any)) as TableProps['sx'])
                : sx) as TableProps['sx'],
        [sx, spacedOutRows],
    );

    return (
        <TableContext.Provider value={tableContextVals}>
            <MuiTable {...tableProps} sx={actualSx} ref={ref}>
                {children}
            </MuiTable>
        </TableContext.Provider>
    );
};

export default React.forwardRef(Table);
